const domainLocalhost = 'http://127.0.0.1:8401';
const domainEngSoft = 'https://dsx.engsoft.app';
const domainEngTest = 'https://dsx.engtest.app';
const domainAdisonNet = 'https://dsx.adisonjimenez.net';
const domainAdisonWork = 'https://dsx.adisonjimenez.work';

export const Environment = {
  production: true,
  // API
  api: {
    java: {
      spring: {
        host: `${domainLocalhost}`,
        app: `${domainEngSoft}/code_lottery_spring`,
        net: `${domainAdisonNet}/code_lottery_spring`,
        test: `${domainEngTest}/code_lottery_spring`,
        work: `${domainAdisonWork}/code_lottery_spring`,
      },
    },
    php: {
      laravel: {
        host: `${domainLocalhost}/code_lottery_laravel`,
        app: `${domainEngSoft}/code_lottery_laravel`,
        net: `${domainAdisonNet}/code_lottery_laravel`,
        test: `${domainEngTest}/code_lottery_laravel`,
        work: `${domainAdisonWork}/code_lottery_laravel`,
      },
      slim: {
        host: `${domainLocalhost}/code_lottery_slim`,
        app: `${domainEngSoft}/code_lottery_slim`,
        net: `${domainAdisonNet}/code_lottery_slim`,
        test: `${domainEngTest}/code_lottery_slim`,
        work: `${domainAdisonWork}/code_lottery_slim`,
      },
    },
  },
  tmpl: {
    smart: {
      host: `${domainLocalhost}/version.4.5.1/html-full/dist`,
      app: `${domainEngSoft}/version.4.5.1/html-full/dist`,
      net: `${domainAdisonNet}/version.4.5.1/html-full/dist`,
      test: `${domainEngTest}/version.4.5.1/html-full/dist`,
      work: `${domainAdisonWork}/version.4.5.1/html-full/dist`,
    },
  },
  // Aplicación
  app: {
    debug: true,
    title: 'Personal',
  },
  // Almacenamiento
  strg: {
    auth: 'csAppAuth',
  },
}
